import { MANUAL_LOCALES } from "../i18n/locale";
import { useManualLocale } from "../i18n/LocaleContext";
import { manualUi } from "../i18n/messages";

export function LanguageSwitch() {
  const { locale, setLocale } = useManualLocale();
  const ui = manualUi(locale);
  return (
    <div className="lang-switch" role="group" aria-label={ui.language}>
      {MANUAL_LOCALES.map((item) => (
        <button
          key={item.code}
          type="button"
          aria-current={locale === item.code ? "true" : undefined}
          onClick={() => setLocale(item.code)}
        >
          {item.label}
        </button>
      ))}
    </div>
  );
}
